// extracted by mini-css-extract-plugin
var _1 = "kIGQH";
var _2 = "N43YX";
var _3 = "_7Xef";
var _4 = "Jvz5D";
var _5 = "B1JD_";
var _6 = "Yg3K5";
var _7 = "kMCzQ";
var _8 = "oAF8D";
var _9 = "Q88FI";
var _a = "SJKTA elide";
export { _1 as "active", _2 as "base", _3 as "button", _4 as "delete", _5 as "disabled", _6 as "edit", _7 as "error", _8 as "icon", _9 as "index", _a as "label" }
